<div class="container">

  <form [formGroup]="officesForm">
    <div class="form-row">
      <div class="col-md-4 mb-3">
        <label for="officeId">Select Office:</label>
        <select id="officeId" class="form-control" formControlName="officeId">
          <option *ngFor="let office of offices" [value]="office.id">{{ office.city + ' ' + office.address }}</option>
        </select>
      </div>
    </div>
  </form>

  <div class="zk-data-container">
    <div class="mt-3 zk-teco-device-data" *ngIf="rtLogs && rtLogs.length > 0">
      <div class="user-list mt-3 mb-3">
        <table class="table table-striped table-responsive-lg">
          <thead>
          <tr>
            <th scope="col" class="text-center">Date and time</th>
            <th scope="col" class="text-center">Door</th>
            <th scope="col" class="text-center">Event</th>
            <th scope="col" class="text-center">User</th>
            <th scope="col" class="text-center">QR/Code</th>
            <th scope="col" class="text-center">In/Out Status</th>
            <th scope="col" class="text-center">Verify Type (QR or Digit)</th>
            <th scope="col" class="text-center">Booking Valid (from-till)</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let log of rtLogs | paginate : {
                  itemsPerPage: pageSize,
                  currentPage: pageNumber,
                  totalItems: totalElements
                };
          let i = index ">
            <td>{{ log.time | date:'dd.MM.yy HH:mm:ss' }}</td>
            <td class="text-center">{{ log.doorNumber }}</td>
            <td class="text-center">{{ log.event }}</td>
            <td class="text-center">
              <ng-container *ngIf="log.badgeNumber != 0">
                {{ log.badgeNumber }}
              </ng-container>
              <ng-container *ngIf="log.user">
                {{ log.user.firstname + ' ' + log.user.lastname + ' (' + log.user.email + ')'}}
              </ng-container>
            </td>
            <td class="text-center">
              <ng-container *ngIf="log.cardNumber != 0">{{ log.cardNumber }}</ng-container>
            </td>
            <td class="text-center">{{ log.inOutStatus }}</td>
            <td class="text-center">{{ log.verifyType }}</td>
            <td class="text-center">
              <ng-container *ngIf="log.order">
                {{ log.order.start | date:'dd.MM.yy HH:mm' }} - {{ log.order.end | date:'dd.MM.yy HH:mm' }}
              </ng-container>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-auto">
          <pagination-controls
            previousLabel="Prev"
            nextLabel="Next"
            responsive="true"
            (pageChange)="handlePageChange($event)"></pagination-controls>
        </div>
        <div class="col-md-auto">
          Items per page:
          <select (change)="handlePageSizeChange($event)">
            <option *ngFor="let size of pageSizes" [ngValue]="size">
              {{ size }}
            </option>
          </select>
        </div>
        <div class="col-md-auto">
          <div>{{ getMinLimit() }}-{{ getMaxLimit() }} of {{ totalElements }} items</div>
        </div>
      </div>
    </div>

    <ng-template #emptyLoadingTemplate></ng-template>
    <ngx-loading
      [show]="loading"
      [config]="{
        primaryColour: primaryColour,
        secondaryColour: secondaryColour,
        tertiaryColour: primaryColour,
        backdropBorderRadius: '3px'
      }"
      [template]="emptyLoadingTemplate"></ngx-loading>
  </div>
</div>
